<template>
    <div class="myInvoice">
        <div class="main-title">我的发票</div>

        <div class="page-ctx">
            <div class="tabs-warp">
                <div class="tabs">
                    <div class="item" :class="{ active: tabIndex === index }" v-for="(item, index) in tabs" :key="index" @click="clickItem(index)">
                        <span>
                            {{ item.title }}
                            <span v-if="index != 0" style="color: #ff4d00">
                                {{ index == 1 ? baseInfo.orderNeedFapiao : '' }}{{ index == 2 ? baseInfo.orderFinishFapiao : '' }}
                            </span>
                        </span>
                    </div>
                </div>
                <div class="rbox">
                    <div class="search-box">
                        <input v-model="keyword" type="text" placeholder="请输入" />
                        <div class="queryBtn" @click="searchBtn">
                            <img src="@/assets/img/mine/query.png" class="img" alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="list-warp">
                <InvoiceLsit :list="list" />
            </div>

            <div class="paging-warp" style="margin-top: 40px" v-if="list.length > 0">
                <el-pagination
                    class="el-pagination"
                    background
                    @current-change="change_page"
                    :current-page.sync="page"
                    :page-size="pagenum"
                    layout="total, prev, pager, next"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import InvoiceLsit from './components/InvoiceLsit' //订单列表
import { mapState } from 'vuex'
export default {
    name: 'myInvoice',
    components: {
        InvoiceLsit,
    },
    data() {
        return {
            statusNameMap: {
                //	状态：0-全部 2-待开票 3-已开票
                0: '',
                1: '待开票',
                2: '已开票',
                '-1': '已作废',
            },
            tabs: [
                { status: 99, title: '全部发票' },
                { status: 1, title: '待开票' },
                { status: 2, title: '已开票' },
            ],
            tabIndex: 0,
            list: [], //订单列表
            page: 1,
            pagenum: 10,
            total: 0,
            keyword: '',
        }
    },
    computed: {
        ...mapState(['baseInfo']),
    },
    mounted() {
        this.invoicesGetList()
    },
    methods: {
        searchBtn() {
            this.page = 1
            this.invoicesGetList()
        },
        clickItem(index) {
            this.tabIndex = index
            this.page = 1
            this.keyword = ''
            this.invoicesGetList()
        },
        invoicesGetList() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'orders_lists',
                    invoiceStatus: this.tabs[this.tabIndex].status,
                    page: this.page,
                    pageNum: this.pagenum,
                    keyword: this.keyword,
                },
            }).then((res) => {
                if (res.code == 200) {
                    let { count, list } = res.data
                    // list.forEach((v) => {
                    //     v.products = JSON.parse(v.info)
                    //     // v.info  = v.products[0]
                    //     v.cus_status_title = this.statusNameMap[v.status]
                    // })
                    this.list = list
                    this.total = count ? count : 0
                } else {
                }
            })
        },
        //分页
        change_page(index) {
            this.page = index
            this.invoicesGetList()
        },
    },
}
</script>

<style scoped lang="less">
@import url('css/common.less');
@tabs_theme: #ff4d00;

.myInvoice {
    .el-pagination {
        text-align: end;
    }
}

.tabs-warp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    .tabs {
        display: flex;
        .item + .item {
            margin-left: 40px;
        }
        .item {
            padding: 0 0 10px 0;
            position: relative;
            display: flex;
            align-items: center;
            cursor: pointer;
            position: relative;
            height: 100%;
            background: linear-gradient(to right, @tabs_theme, @tabs_theme) no-repeat right bottom;
            background-size: 0 3px;
            // transition: background-size 200ms;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            white-space: nowrap;
            // &:hover {
            //     background-position-x: left;
            //     color: @tabs_theme;
            //     background-size: 100% 3px;
            // }
            span + span {
                margin-left: 3px;
            }
        }
        .active {
            color: @tabs_theme;
            background-position-x: left;
            background-size: 100% 3px;
        }
    }
    .rbox {
        .search-box {
            .flex();
            width: 220px;
            height: 32px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #b8c4d1;
            padding-right: 10px;
            overflow: hidden;

            input {
                background: #ffffff;
                flex: 2;
                height: 100%;
                // border: 1px solid #e2e2e2;
                border-right: none;
                outline: none;
                padding-left: 10px;
                font-size: 12px;
            }

            .queryBtn {
                width: 18px;
                height: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                .img {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }
}
@media screen and (max-width: 1024px) {
    .myInvoice {
        .el-pagination {
            text-align: end;
        }
    }

    .tabs-warp {
        display: flex;
        justify-content: space-between;
        flex-direction: column-reverse;
        margin-bottom: 24px;
        .tabs {
            margin-top: 10px;
            display: flex;
            .item + .item {
                margin-left: 40px;
            }
            .item {
                padding: 0 0 10px 0;
                position: relative;
                display: flex;
                align-items: center;
                cursor: pointer;
                position: relative;
                height: 100%;
                background: linear-gradient(to right, @tabs_theme, @tabs_theme) no-repeat right bottom;
                background-size: 0 3px;
                // transition: background-size 200ms;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                white-space: nowrap;
                // &:hover {
                //     background-position-x: left;
                //     color: @tabs_theme;
                //     background-size: 100% 3px;
                // }
                span {
                    font-size: 16px;
                }
                span + span {
                    margin-left: 3px;
                }
            }
            .active {
                color: @tabs_theme;
                background-position-x: left;
                background-size: 100% 3px;
            }
        }
        .rbox {
            .search-box {
                .flex();
                width: 220px;
                height: 32px;
                background: #ffffff;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #b8c4d1;
                padding-right: 10px;
                overflow: hidden;

                input {
                    background: #ffffff;
                    flex: 2;
                    height: 100%;
                    // border: 1px solid #e2e2e2;
                    border-right: none;
                    outline: none;
                    padding-left: 10px;
                    font-size: 12px;
                }

                .queryBtn {
                    width: 18px;
                    height: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    .img {
                        width: 18px;
                        height: 18px;
                    }
                }
            }
        }
    }
}
</style>
 
